<template>
  <div class="credentials-item">
    <hs-cell-1 :showLogo="false" :show-separator="false">
      <div class="title">
        <span class="credential-name">{{ details.CredentialName }}</span>
        <span
          v-if="IsEnableBusinessEdit"
          class="del"
          @click="$emit('delCredential')"
        ></span>
      </div>
    </hs-cell-1>
    <hs-form-cell-des
        v-model="details.CredentialNo"
        :class="CredentialNoSetting.ClassName"
        :title="$t('IDNumber')"
        :type="CredentialNoSetting.Type"
        :placeholder="CredentialNoSetting.Placeholder"
        :edit="CredentialNoSetting.Edit"
        telFunName="certificatesDes"
        :IsEnableDesensitize="CredentialNoSetting.IsEnableDesensitize"
        :errTips="CredentialNoSetting.ErrTips"
        :is-show-error="CredentialNoSetting.IsShowError"
        :required="CredentialNoSetting.Required"
        clearable
    />
    <hs-form-cell
        v-if="EffectiveDateSetting.Show"
        :class="EffectiveDateSetting.ClassName"
        @click="$emit('openSelectEffectiveDate', details)"
        v-model="details.EffectiveDate"
        :title="EffectiveDateSetting.Name"
        :type="EffectiveDateSetting.Type"
        :placeholder="EffectiveDateSetting.Placeholder"
        :edit="EffectiveDateSetting.Edit"
        :showLogo="EffectiveDateSetting.ShowLogo"
        :errTips="EffectiveDateSetting.ErrTips"
        :is-show-error="EffectiveDateSetting.IsShowError"
        :required="EffectiveDateSetting.Required"
    />
    <!--证件签署国-->
    <hs-form-cell
        v-if="CredentialNationSetting.Show"
        :class="CredentialNationSetting.ClassName"
        @click="$emit('openSelectCredentialNation', details)"
        :value="details.Nation ? details.Nation.Name : ''"
        :title="CredentialNationSetting.Name"
        :type="CredentialNationSetting.Type"
        :placeholder="CredentialNationSetting.Placeholder"
        :edit="CredentialNationSetting.Edit"
        :showLogo="CredentialNationSetting.ShowLogo"
        :errTips="CredentialNationSetting.ErrTips"
        :is-show-error="CredentialNationSetting.IsShowError"
        :required="CredentialNationSetting.Required"
    />
  </div>
</template>

<script>
import HsCellSmallTitle from "base/hs-tableview/hs-cell-small-title/hs-cell-small-title";
import HsCell1 from "base/hs-tableview/hs-cell-1/hs-cell-1";
import mixinDes from "common/mixin/passenger/mixin-des";
import HsFormCellDes from "@/base/hs-tableview/hs-section/hs-form-cell-des.vue";
import HsFormCell from "@/base/hs-tableview/hs-section/hs-form-cell.vue";
import {getMarkClassName} from "@/pages/personal/passengers/passenger-details/details";
export default {
  props: {
    details: {
      type: Object,
      default: () => {
        return {};
      },
    },
    IsEnableBusinessEdit: {
      type: Boolean,
      default: false,
    },
    ExpirationTime: {
      type: String,
      default: "",
    },
    submitChecked: {
      type: Boolean,
      default: false,
    },
    IsEnableDesensitize: { // this.IsEnableDesensitize 员工非员工的 true 不读隐私保护权限
      type: Boolean,
      default: false,
    }
  },
  computed: {
    CredentialNoSetting() {
      let Required = true
      let IsShowError = false
      let ErrTips = ''
      let CredentialNo = this.details.CredentialNo
      if (this.submitChecked && Required) {
        if (!CredentialNo) {
          IsShowError = true
          ErrTips = ''
        }
      }
      if (this.details.CredentialType === 1) {
        let checkObj = this.idCard(CredentialNo)
        if (CredentialNo && !checkObj.valid) {
          IsShowError = true
          ErrTips = checkObj.msg
        }
      }
      return {
        Show: true,
        Name: this.$t('IDNumber'),
        ClassName: getMarkClassName('listCredentialNo'),
        Required: Required,
        Type: 'input',
        Edit: this.IsEnableBusinessEdit,
        IsEnableDesensitize: this.IsEnableDesensitize,
        Placeholder: this.IsEnableBusinessEdit ? this.$getPlaceholder(0, false) : this.$t('Unmodifiable'),
        ShowLogo: this.IsEnableBusinessEdit,
        IsShowError,
        ErrTips,
      }
    },
    EffectiveDateSetting() {
      let ExpireDateSetting = Number(this.details.ExpireDateSetting)
      let Show = ExpireDateSetting === 1 || ExpireDateSetting === 2
      let Required = ExpireDateSetting === 2
      let IsShowError = false
      let ErrTips = ''
      if (Required && this.submitChecked && !this.details.EffectiveDate) {
        IsShowError = true
        ErrTips = ''
      }
      if (Show) {
        ErrTips = this._checkEffectiveDate()
        IsShowError = !!ErrTips
      }
      return {
        Show,
        Name: this.$t('EffectiveDate'),
        ClassName: getMarkClassName('listEffectiveDate'),
        Required: Required,
        Type: 'disabled-input',
        Edit: this.IsEnableBusinessEdit,
        Placeholder: this.IsEnableBusinessEdit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: this.IsEnableBusinessEdit,
        IsShowError,
        ErrTips,
      }
    },
    CredentialNationSetting() {
      let CredentialNation = Number(this.details.CredentialNation)
      let Show = CredentialNation === 1 || CredentialNation === 2
      let Required = CredentialNation === 2
      let IsShowError = false
      let ErrTips = ''
      let Edit = true
      if (Required && this.submitChecked && (!this.details.Nation || !this.details.Nation.Name)) {
        IsShowError = true
        ErrTips = ''
      }
      if (Show) {
        IsShowError = !!ErrTips
      }
      return {
        Show,
        Name: this.$t('DocumentSignatory'),
        ClassName: getMarkClassName('listNation'),
        Required: Required,
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: Edit,
        IsShowError,
        ErrTips,
      }
    },
  },
  mixins: [mixinDes],
  methods: {
    // 校验证件有效期
    _checkEffectiveDate() {
      let ExpireDateSetting = Number(this.details.ExpireDateSetting);
      if (
        (ExpireDateSetting === 1 || ExpireDateSetting === 2) &&
        this.details.EffectiveDate &&
        this.details.EffectiveDate < this.ExpirationTime
      ) {
        return this.$t('TheValidityPeriodHasExpired')
      } else {
        return ''
      }
    },

    localCheck() {
      if (this.CredentialNoSetting.Show && this.CredentialNoSetting.IsShowError) {
        this.$toast(
            this.CredentialNoSetting.ErrTips ||
            this.$t('PleaseFill_x', 'function', [this.CredentialNoSetting.Name])
        )
        return this.CredentialNoSetting.ClassName
      }
      if (this.EffectiveDateSetting.Show && this.EffectiveDateSetting.IsShowError) {
        this.$toast(this.EffectiveDateSetting.ErrTips || this.$t('PleaseSelect_x', 'function', [this.EffectiveDateSetting.Name]))
        return this.EffectiveDateSetting.ClassName
      }
      if (this.CredentialNationSetting.Show && this.CredentialNationSetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.CredentialNationSetting.Name]))
        return this.CredentialNationSetting.ClassName
      }
    },
  },
  components: {
    HsFormCell,
    HsFormCellDes,
    HsCellSmallTitle,
    HsCell1,
  },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.credentials-item
  &::after
    display flex
    content ' '
    width calc(100% - 30px)
    margin-left 15px
    // border-bottom 1px solid $color_gray_layer
  &:last-child
    &::after
      display none
.title
  @extends .flex-between
  padding 10px 0
  width 100%
  min-height 56px
  >.credential-name
    @extends .flex-start
    @extends .hs-font-subtitle-middle
  >.del
    width 30px
    height 30px
    background url(@/assets/image/base/cell/icons_16pt_trash.png) center center no-repeat
    background-size 16px 16px
    // 添加证件信息
</style>
